import React, { useState } from "react";
import clsx from "clsx";
import * as clipboard from "clipboard-polyfill";
import {
  FacebookShareButton,
  TwitterShareButton,
  LinkedinShareButton,
} from "react-share";

import { ReactComponent as FacebookIcon } from "@/assets/svg/facebook-ico.svg";
import { ReactComponent as LinkedinIcon } from "@/assets/svg/linkedin-ico.svg";
import { ReactComponent as LinkIcon } from "@/assets/svg/link.svg";
import { ReactComponent as TwitterIcon } from "@/assets/svg/twitter-ico.svg";

import * as styles from "./styles.module.css";

interface Props {
  path?: string;
}

export default function SocialShare({ path = "/" }: Props) {
  const [copied, setCopied] = useState(false);

  const copyLink = () => {
    clipboard
      .writeText(path)
      .then(
        () => {
          setCopied(true);
          return setTimeout(() => setCopied(false), 1500);
        },
        (err) => {
          // eslint-disable-next-line no-console
          return console.log("Not COPIED because of error: ", err);
        }
      )
      // eslint-disable-next-line no-console
      .catch((error) => console.log(error));
  };

  return (
    <section className={clsx("flex w-full text-white", styles.wrapper)}>
      <TwitterShareButton url={path}>
        <TwitterIcon />
      </TwitterShareButton>
      <LinkedinShareButton url={path}>
        <LinkedinIcon />
      </LinkedinShareButton>
      <FacebookShareButton url={path}>
        <FacebookIcon />
      </FacebookShareButton>
      <div className="relative">
        <button
          className="bg-black"
          onClick={copyLink}
          aria-label="Copy link"
          title="Copy link"
        >
          <LinkIcon />
        </button>
        <div
          role="status"
          className={clsx(
            "absolute whitespace-pre mt-3 transition-all duration-300 ease-in-out",
            styles.success__toast,
            {
              "opacity-100": copied,
              "opacity-0": !copied,
            }
          )}
        >
          Link copied
        </div>
      </div>
    </section>
  );
}
